// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Header_tabs__i1ynS","spacing":"Header_spacing__6JIWf","actions":"Header_actions__tW_xj","idleButtonPaused":"Header_idleButtonPaused__d_iCK"};